import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { DimensionsSummaryProps } from "models/propTypes/invoicePropTypes";
import { KeyValue } from "models/utilTypes/keyValue";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { DetailsTableViewSmall } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DimensionsSummary: React.FC<DimensionsSummaryProps> = (props) => {
  const { value } = props;

  const { dimensionTypes, dimensions } = useSelector((store: AppState) => ({
    dimensionTypes: store.auth.selectedCompany.invoiceDimensionTypes ?? [],
    dimensions: store.common.dimensions.invoiceDimensions ?? [],
  }));

  const dimensionDetails: Array<KeyValue<string, string> | typeof ACTION_SEPARATOR> = dimensionTypes
    .map((dimType) => {
      const selectedDimensionIds = value?.map((dim) => dim.dimensionId);

      const all = dimensions.find((d) => d.key.id === dimType.id);

      return all
        ? all.value
            .filter((item) => selectedDimensionIds.includes(item.id as string))
            .map((item, index) => {
              const selectedDim = value.find((d) => d.dimensionId === item.id);

              return new KeyValue(
                index === 0 ? dimType.name ?? "" : "",
                `${item.name} (${LocalizationHelperInstance.getFormattedCurrency(
                  selectedDim?.amount ?? 0,
                  props.currency
                )})`
              );
            })
        : [];
    })
    .filter((dt) => dt.length > 0)
    .flatMap((dt, index) => (index > 0 ? [ACTION_SEPARATOR, ...dt] : dt));

  return <DetailsTableViewSmall detailsList={dimensionDetails} hideButton />;
};

export default DimensionsSummary;
